import * as React from 'react';
import { cn } from '@/shared/lib/cn';
import styles from './Input.module.css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

/**
 * Однострочный ввод (и Textarea рядом) — всё, куда человек печатает текст.
 * Сырой `<input>` не получит ни фокусных состояний, ни геометрии из токенов,
 * поэтому его в разметке быть не должно.
 *
 * Внутри формы оборачивается в Field: плавающий лейбл, подпись, состояние
 * ошибки. Голый Input уместен вне формы — строка поиска, инлайн-правка.
 *
 * @use ввод текста; Textarea — многострочный. Внутри формы оборачивается в Field.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || undefined}
      className={cn(styles.input, invalid && styles.invalid, className)}
      {...rest}
    />
  );
});

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(styles.input, styles.textarea, invalid && styles.invalid, className)}
      {...rest}
    />
  );
});
